<template>
    <div v-if="list_elements.length">
        <div
            v-for="element in list_elements"
            :key="element.id_element"
            :data-id-element="element.id_element"
            :style="{ left: element.position_x + '%', top: element.position_y + '%', width: element.width + '%' }"
            class="container-element"
        >
            <template v-if="element.type_evenement === 'click'">
                <form
                    :id="'form-evenement-' + element.id_evenement"
                    :class="['form-notification-' + element.id_evenement, element.parametres?.class || '']"
                    method="post"
                    @submit.prevent
                >
                    <!-- CSRF TOKEN -->
                    <!-- Id de l'evenement à transmettre -->
                    <input type="hidden" id="input-id-parent" name="id_parent" :value="element.id_evenement">
                    <!-- Traitement des actions en ajax -->
                    <div
                        class="container-html-element"
                        @click="ajax_traitement_list_action(
                            element.id_evenement,
                            'evenement',
                            false,
                            $event,
                            $event.target
                        )"
                    >
                        <!-- Contenu de l'élément -->
                        <div v-html="element.html"></div>
                    </div>
                </form>
            </template>
            <template v-else>
                <div v-html="element.html"></div>
            </template>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'ListElementsComponent',
        props: {
            list_elements: {
                type: Array,
                required: true,
                default: () => []
            },
        },
        data() {
            return {
                csrfTokenName: window.csrf_name,
                csrfTokenValue: window.csrf_value
            };
        },
        methods: {
            getCsrfToken() {
                // Récupérer le token CSRF depuis le document ou le stockage local si nécessaire
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            ajax_traitement_list_action(id_evenement) {
                // Implémentez la logique de traitement des actions Ajax ici
                console.log('Action AJAX déclenchée pour:', id_evenement);
            }
        }
    };
</script>